import React from "react";

const EmptyList = () => (
    <div className='emptyList-wrap'>
        <img src = {require('../images/' + "13525-empty.gif")} alt='empty' />
    </div>
);

export default EmptyList;